import React, { PureComponent } from 'react';
import { volcengineAndH5Statistics } from '@ifeng-fe/mobile_statistics';
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { WxLaunchApp } from '../../wxLaunchApp';
import styles from './index.css';
class WxLaunchHack extends PureComponent {
    constructor(props) {
        super(props);
        this.callAppHandle = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
            const { statisticsConfig = {}, callAppConfig = {}, launchAppClick, launchAppFail, callAppClick, appid } = this.props.content;
            if (callAppClick) {
                callAppClick();
            }
            if (isSendCount) {
                volcengineAndH5Statistics(statisticsConfig);
                if (launchAppClick) {
                    launchAppClick();
                }
            }
            if (isCallApp) {
                if (launchAppFail) {
                    launchAppFail();
                }
                callApp(Object.assign(Object.assign({}, callAppConfig), { isCopySchemeUrl: isJumpQQlink }));
            }
        };
        this.getStyle = (obj, name) => {
            // @ts-ignore
            if (typeof window !== 'undefined' && window.getComputedStyle) {
                return getComputedStyle(obj, null)[name];
            }
            else {
                return obj.currentStyle[name];
            }
        };
        this.schemeLink = getSchemeLink(this.props.content.callAppConfig);
        this.launchAppHack = React.createRef();
    }
    componentDidMount() {
        const launchAppDom = this.launchAppHack.current;
        if (launchAppDom && launchAppDom.parentElement) {
            const parentElementDom = launchAppDom.parentElement;
            const parentElementPosition = this.getStyle(parentElementDom, 'position');
            if (parentElementPosition === 'static' || parentElementPosition === '') {
                parentElementDom.style.position = 'relative';
            }
        }
    }
    render() {
        var _a, _b;
        return (React.createElement("div", { className: styles.wxLauchHack, ref: this.launchAppHack, onClick: () => {
                this.callAppHandle();
            } },
            React.createElement(WxLaunchApp, { launchType: "app", launchAppClick: () => {
                    this.callAppHandle(true, false, false);
                }, appid: ((_b = (_a = this === null || this === void 0 ? void 0 : this.props) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.appid) || '', schemeLink: this.schemeLink, launchAppFail: () => {
                    this.callAppHandle(false, true, true);
                } })));
    }
}
export default WxLaunchHack;
